/**
 * MFC API Gategway URL
 */
export const apiGatewayUrl = import .meta.env.VITE_MFC_API_APP_URL;

/**
 * This constant is the href value of the porsche preauthorization
 * page.
 */
export const hrefPreauthorization = import .meta.env.VITE_PREAUTHORIZATION;
